// extracted by mini-css-extract-plugin
export var articleListWrapper = "index-module--article-list-wrapper--4v3FF";
export var headingWrapper = "index-module--heading-wrapper--cYfoa";
export var main = "index-module--main--7FkRy";
export var mainHeadingWrapper = "index-module--main-heading-wrapper--aqH5r";
export var nav = "index-module--nav--DVujb";
export var paginationWrapper = "index-module--pagination-wrapper--3m3Sr";
export var section = "index-module--section--9CvHE";
export var totalBadgeWrapper = "index-module--total-badge-wrapper--bsC+x";